import type { AlertSeverity } from '../api/types';

/**
 * Brand-aligned alert severity colors.
 * - info    → sidebar/primary blue
 * - warning → chart orange
 * - critical → chart red
 */
export const ALERT_SEVERITY_COLORS: Record<AlertSeverity, string> = {
    critical: '#C0152A',
    warning: '#FF9800',
    info: '#066fd5',
    log: '', // resolved at runtime from theme.palette.text.secondary
};

export function alertSeverityColor(
    severity: AlertSeverity,
    textSecondary: string,
): string {
    return ALERT_SEVERITY_COLORS[severity] || textSecondary;
}